export default __webpack_public_path__ + "static/media/ksivalue_mobile_small@2x.ded1632f.jpg";